import { IStorageProductViewModel } from 'Interfaces/IStorageConfig';
import { GenerateGuid, isGuidEmpty, normalizeGuidOrNull } from './GuidChecks';

import {
  ICompanyProductAddViewModel,
  ICompanyProductViewModel,
} from 'Interfaces/ICompanyProductConfig';
import {
  EnumCompanyProductStatus,
  EnumPlacement,
  EnumProductSecurity,
} from 'Interfaces/IGlobalTypeConfig';
import { IBillingProductViewModel } from 'pages/Billing/BillingConfig';
import { IProductViewModel } from 'Interfaces/IProductConfig';

export const ConvertStorageProductToCompanyProduct = (
  storageProduct: IStorageProductViewModel
): ICompanyProductViewModel => {
  return {
    id: storageProduct.id,
    serviceTag: storageProduct.resourceName || '',
    productId: storageProduct.product?.id || '',
    companyId: GenerateGuid(),
    purchaserId: GenerateGuid(),
    ownerId: null,
    owner: null,
    comment: '',
    lastBilled: null,
    productQuantity: 1,
    quantity: 1, //xxx
    unitPrice: storageProduct.unitPrice,
    discount: storageProduct.discount || 0,
    retailPrice: storageProduct.retailPrice,
    lifetime: storageProduct.product?.productType?.lifeExpectancy || 3, //xxx
    security: true, //xxx
    status: 0, //xxx
    productWarning: '',
    product: storageProduct.product,
    placement: EnumPlacement.EMPLOYEE,
    isActive: true,
    isBillable: true,
    serialNumber: storageProduct.serialNumber || '',
    resource: null,
    resourceId: null,
    toggleEdit: false,
    guaranteeEndDate: null,
    isDateEditable: false,
  };
};

export const ConvertBillingProductToCompanyProduct = (
  productCatalog: IBillingProductViewModel
): ICompanyProductViewModel => {
  return {
    id: GenerateGuid(),
    serviceTag: '',
    productId: productCatalog?.id || '',
    companyId: GenerateGuid(),
    purchaserId: GenerateGuid(),
    ownerId: null,
    owner: null,
    comment: '',
    lastBilled: null,
    productQuantity: 1,
    quantity: 1, //xxx
    unitPrice: productCatalog.unitPrice,
    discount: 0,
    retailPrice: productCatalog.retailPrice,
    lifetime: productCatalog?.productType?.lifeExpectancy || 3, //xxx
    security: true, //xxx
    status: 0, //xxx
    productWarning: '',
    product: productCatalog,
    placement: EnumPlacement.EMPLOYEE,
    isActive: true,
    isBillable: true,
    serialNumber: productCatalog.serialNumber,
    resource: null,
    resourceId: null,
    toggleEdit: false,
    guaranteeEndDate: null,
    isDateEditable: false,
  };
};

export const ConvertProductToCompanyProduct = (
  productCatalog: IBillingProductViewModel
): ICompanyProductViewModel => {
  return {
    id: GenerateGuid(),
    serviceTag: '',
    productId: productCatalog?.id || '',
    companyId: GenerateGuid(),
    purchaserId: GenerateGuid(),
    ownerId: null,
    owner: null,
    comment: '',
    lastBilled: null,
    productQuantity: 1,
    quantity: 1, //xxx
    unitPrice: productCatalog.unitPrice,
    discount: 0,
    retailPrice: productCatalog.retailPrice,
    lifetime: productCatalog?.productType?.lifeExpectancy || 3, //xxx
    security: true, //xxx
    status: 0, //xxx
    productWarning: '',
    product: productCatalog,
    placement: EnumPlacement.EMPLOYEE,
    isActive: true,
    isBillable: true,
    serialNumber: productCatalog.serialNumber,
    resource: null,
    resourceId: null,
    toggleEdit: false,
    guaranteeEndDate: null,
    isDateEditable: false,
  };
};

export const ConvertProductToCompanyAddProduct = {
  convert: (
    product: any,
    companyId: string,
    additionalData?: {
      vendorId?: string | null;
      ownerId?: string | null;
      resourceId?: string | null;
      discount?: number;
      lifetime?: number;
      placement?: EnumPlacement;
      productWarning?: string;
      status?: number;
    }
  ): ICompanyProductAddViewModel => {
    console.log('Convert:', product, 'and companyId:', companyId);
    if (!product) {
      throw new Error('ConvertProductToCompanyAddProduct.convert: product mangler');
    }

    const productId =
      normalizeGuidOrNull(product.productId) ??
      normalizeGuidOrNull(product.id);

    if (!productId) {
      throw new Error('ConvertProductToCompanyAddProduct.convert: mangler productId');
    }

    const ownerId = normalizeGuidOrNull(additionalData?.ownerId);
    const vendorId =
      normalizeGuidOrNull(additionalData?.vendorId ?? product.vendorId);
    const resourceId = normalizeGuidOrNull(additionalData?.resourceId);

    // purchaserId må være string, ikke null
    const purchaserId = !isGuidEmpty(product.purchaserId)
      ? product.purchaserId.trim()
      : '';

    const unitPrice =
      typeof product.unitPrice === 'number'
        ? product.unitPrice
        : typeof product.product?.unitPrice === 'number'
        ? product.product.unitPrice
        : 0;

    const convertedProduct: ICompanyProductAddViewModel = {
      serviceTag: '',
      productId,
      companyId,
      purchaserId,
      vendorId: vendorId ?? null,
      vendorProductUrl: product.vendorProductUrl || null,
      ownerId,
      resourceId,
      comment: product.comment || '',
      unitPrice,
      retailPrice:
        typeof product.retailPrice === 'number'
          ? product.retailPrice
          : unitPrice,
      quantity:
        typeof product.quantity === 'number' && product.quantity > 0
          ? product.quantity
          : 1,
      discount: additionalData?.discount ?? 0,
      lifetime: additionalData?.lifetime ?? 0,
      securityValue: EnumProductSecurity.None,
      status:
        (additionalData?.status as EnumCompanyProductStatus) ??
        EnumCompanyProductStatus.NONE,
      productWarning: additionalData?.productWarning || '',
      placement: additionalData?.placement ?? EnumPlacement.NONE,
      serialNumber: product.serialNumber || '',
      productChanges: undefined,
    };

    return convertedProduct;
  },
};


